import localConfig from '@/config';
import { normalizeParamsObject } from 'shared-lib/helpers/formatters';

const types = {
    SAVE_FILTERS: 'SAVE_PROXIES_FILTERS',
    RESET_FILTERS: 'RESET_PROXIES_FILTERS',
};

const initialState = {
    data: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-created',
        },
    },
};

const state = {
    ...initialState,
};


const getters = {
    proxiesFilters: state => state.data.filters,
};


const actions = {
    saveProxiesFilters ({ commit }, payload) {
        commit(types.SAVE_FILTERS, { payload });
    },
    resetProxiesFilters ({ commit }) {
        commit(types.RESET_FILTERS);
    },
};


const mutations = {
    [types.SAVE_FILTERS] (state, { payload }) {
        let payloadNormalized = normalizeParamsObject(payload);
        state.data = {
            ...state.data,
            filters: { ...payloadNormalized },
        };
    },
    [types.RESET_FILTERS] (state) {
        state.data.filters = { ...initialState.data.filters };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
